const NAVBAR_HEIGHT = 80;

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export const scrollToBooking = () => scrollToSection("booking-form");
